import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 85px; 
    }`
  }
`

const RedirectButtonIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="110" height="31" viewBox="0 0 110 31" isFromWidgetChoice={isFromWidgetChoice}>
      <g id="filter_select" transform="translate(1355 -9391)">
      
        <g className="strokeHoverSVG" id="Rectangle_2737" data-name="Rectangle 2737" transform="translate(-1355 9391)" fill="none" stroke="#787878" strokeWidth="2">
          <rect width="110" height="31" rx="5" stroke="none" />
          <rect className="strokeHoverSVG" x="1" y="1" width="108" height="29" rx="4" fill="none" />
        </g>
      </g>
      <text
        className="fillHoverSVG"
        fontWeight="normal"
        fontSize="17"
        fill="#787878"
        fontFamily="Roboto-Black, Roboto"
        x="23.295591"
        y="21.745516"
      >
        <tspan
          x="23.295591"
          y="21.745516"
        >
          {"Action >"}
        </tspan>
      </text>
    </SVG>
  </IconContainer>
)

export default RedirectButtonIcon